import { EmissionSourceType } from "./enums";

/** The frontend route of each emission source's data-entry page, below `/customer/:customerId/ccf/:calculationId/`. */
export const CCF_DATA_ENTRY_ROUTE_SEGMENTS = {
  [EmissionSourceType.ELECTRICITY]: "electricity",
  [EmissionSourceType.DIRECT_COMBUSTION]: "direct-combustion",
  [EmissionSourceType.COOLING]: "cooling",
  [EmissionSourceType.HEATING_AND_FUEL]: "heating",
  [EmissionSourceType.VEHICLE_FLEET]: "vehicle-fleet",
  [EmissionSourceType.DIRECT_FUGITIVE]: "direct-fugitive",
  [EmissionSourceType.PRODUCTION_MATERIALS]: "production-materials",
  [EmissionSourceType.PACKAGING]: "packaging",
  [EmissionSourceType.PURCHASED_SERVICE]: "purchased-service",
  [EmissionSourceType.OPERATING_SUPPLIES]: "operating-supplies",
  [EmissionSourceType.FOOD_AND_BEVERAGES]: "food-and-beverages",
  [EmissionSourceType.EXTERNAL_DATA_CENTER]: "external-data-center",
  [EmissionSourceType.WATER]: "water",
  [EmissionSourceType.CAPITAL_GOODS]: "capital-goods",
  [EmissionSourceType.DISPOSAL]: "disposal",
  [EmissionSourceType.PRIVATE_AND_RENTAL_VEHICLE]: "private-and-rental-vehicle",
  [EmissionSourceType.RAIL_TRAVEL]: "train",
  [EmissionSourceType.FLIGHT]: "flight",
  [EmissionSourceType.HOTEL_STAYS]: "hotel-stays",
  [EmissionSourceType.EMPLOYEE_COMMUTING]: "employee-commuting",
  [EmissionSourceType.UPSTREAM_LEASED_ASSETS_ELECTRICITY]: "upstream-leased-assets-electricity",
  [EmissionSourceType.UPSTREAM_LEASED_ASSETS_COMBUSTION]: "upstream-leased-assets-combustion",
  [EmissionSourceType.UPSTREAM_LEASED_ASSETS_COOLING]: "upstream-leased-assets-cooling",
  [EmissionSourceType.UPSTREAM_LEASED_ASSETS_FUGITIVE]: "upstream-leased-assets-fugitive",
  [EmissionSourceType.INBOUND_LOGISTICS]: "inbound-logistics",
  [EmissionSourceType.INTRALOGISTICS]: "intralogistics",
  [EmissionSourceType.OUTBOUND_LOGISTICS]: "outbound-logistics",
  [EmissionSourceType.STORAGE_UPSTREAM]: "storage-upstream",
  [EmissionSourceType.STORAGE_DOWNSTREAM]: "storage-downstream",
  [EmissionSourceType.PROCESSING_OF_SOLD_PRODUCTS_ELECTRICITY]: "processing-of-sold-products-electricity",
  [EmissionSourceType.PROCESSING_OF_SOLD_PRODUCTS_COMBUSTION]: "processing-of-sold-products-combustion",
  [EmissionSourceType.PROCESSING_OF_SOLD_PRODUCTS_COOLING]: "processing-of-sold-products-cooling",
  [EmissionSourceType.PROCESSING_OF_SOLD_PRODUCTS_FUGITIVE]: "processing-of-sold-products-fugitive",
  [EmissionSourceType.PROCESSING_OF_SOLD_PRODUCTS_WASTE]: "processing-of-sold-products-waste",
  [EmissionSourceType.USE_OF_SOLD_PRODUCTS_ELECTRICITY]: "use-of-sold-products-electricity",
  [EmissionSourceType.USE_OF_SOLD_PRODUCTS_COMBUSTION]: "use-of-sold-products-combustion",
  [EmissionSourceType.USE_OF_SOLD_PRODUCTS_COOLING]: "use-of-sold-products-cooling",
  [EmissionSourceType.USE_OF_SOLD_PRODUCTS_FUGITIVE]: "use-of-sold-products-fugitive",
  [EmissionSourceType.USE_OF_SOLD_PRODUCTS_OTHER]: "use-of-sold-products-other",
  [EmissionSourceType.PRODUCT_DISPOSAL]: "product-disposal",
  [EmissionSourceType.DOWNSTREAM_LEASED_ASSETS_ELECTRICITY]: "downstream-leased-assets-electricity",
  [EmissionSourceType.DOWNSTREAM_LEASED_ASSETS_COMBUSTION]: "downstream-leased-assets-combustion",
  [EmissionSourceType.DOWNSTREAM_LEASED_ASSETS_COOLING]: "downstream-leased-assets-cooling",
  [EmissionSourceType.DOWNSTREAM_LEASED_ASSETS_FUGITIVE]: "downstream-leased-assets-fugitive",
  [EmissionSourceType.FRANCHISE]: "franchise",
  [EmissionSourceType.INVESTMENT]: "investment",
} as const satisfies Record<EmissionSourceType, string>;
